import React, { useEffect, useState } from "react";
import { Col, Container, Input, Row, Spinner } from "reactstrap";
import { API_URL } from "../../config";
import { Link } from "react-router-dom";
import { formatDate } from "../../helpers/utils";

const TransactionList = () => {
  const [currencyData, setcurrencyData] = React.useState(null);
  const [displayData, setDisplayData] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [allData, setAllData] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const limit = 10; // items per page
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState(null);
  const [status, setStatus] = useState(null);
  const [type, setType] = useState(null);
  const [currency, setCurrency] = useState(null);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const fetchCurrency = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(API_URL + "/api/wallet/getCurrency", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      if (!response.status === true) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status) {
        const CurrencyDetails = data?.getCurrencyTblDetails || [];

        setcurrencyData(CurrencyDetails);
      } else {
        throw new Error(data.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchTransactionData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(API_URL + "/api/wallet/getTransactions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({
          formvalue: {
            currencyId: currency || "",
            depositType: "",
            fromdate: fromDate || "",
            searchQuery: search || "",
            status: status || "",
            todate: toDate || "",
            type: type || "",
          },
        }),
      });

      if (!response.status === true) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status) {
        const TransactionData = data?.getTransactionsTblDetails || [];
        setAllData(TransactionData);
        // Initialize display data
        filterData(TransactionData, selectedCurrency, 1);
      } else {
        throw new Error(data.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const filterData = (data, currency, pageNumber) => {
    let filtered = data;
    if (currency) {
      filtered = data.filter(
        (item) => item.currencyId?.currencySymbol === currency
      );
    }
    const total = filtered.length;
    setTotalPages(Math.ceil(total / limit));

    const startIndex = (pageNumber - 1) * limit;
    const paginatedData = filtered.slice(startIndex, startIndex + limit);
    setDisplayData(paginatedData);
  };

  useEffect(() => {
    fetchTransactionData();
    fetchCurrency();
  }, []);

  useEffect(() => {
    filterData(allData, selectedCurrency, 1);
  }, [allData, selectedCurrency]);

  const HandleFilter = () => {
    fetchTransactionData();
  };
  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col>
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 font-size-18">Transaction List</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="w-100 d-sm-flex align-items-center justify-content-between">
              <div className="r-g-5">
                <div>
                  <label>Search</label>
                  <Input
                    type="text"
                    id="currrency_Name"
                    name="currrency_Name"
                    className="form-control"
                    placeholder="Currency Name"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div>
                  <label>Transaction Status</label>
                  <select
                    className="form-control w-auto"
                    style={{
                      appearance: "auto",
                      WebkitAppearance: "auto",
                      MozAppearance: "auto",
                    }}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">All Transactions</option>

                    <option value="0">Pending</option>
                    <option value="1">Completed</option>
                    <option value="2">Rejected</option>
                    <option value="5">Processing</option>
                  </select>
                </div>
                <div>
                  <label>Type</label>
                  <select
                    // value={selectedCurrency}
                    // onChange={handleCurrencyChange}
                    className="form-control w-auto"
                    onChange={(e) => setType(e.target.value)}
                    style={{
                      appearance: "auto",
                      WebkitAppearance: "auto",
                      MozAppearance: "auto",
                    }}
                  >
                    <option value="">All Type</option>
                    <option value="Deposit">Deposit</option>
                    <option value="Withdraw">Withdraw</option>
                    <option value="Wallet Transfer">Wallet Transfer</option>
                    <option value="Main Wallet To P2P Wallet">
                      Main Wallet To P2P Wallet
                    </option>
                    <option value="P2P Wallet To Main Wallet">
                      P2P Wallet To Main Wallet
                    </option>
                    <option value="Main Wallet To USD-M Wallet">
                      Main Wallet To USD-M Wallet
                    </option>
                    <option value="USD-M Wallet To Main Wallet">
                      USD-M Wallet To Main Wallet
                    </option>
                  </select>
                </div>
                <div>
                  <label>Currency</label>
                  <select
                    className="form-control w-auto"
                    style={{
                      appearance: "auto",
                      WebkitAppearance: "auto",
                      MozAppearance: "auto",
                    }}
                    onChange={(e) => setCurrency(e.target.value)}
                  >
                    <option value="">All Currencies</option>
                    {currencyData?.map((currency) => (
                      <option key={currency?._id} value={currency?._id}>
                        {currency?.currencySymbol}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label>From date</label>

                  <Input
                    type="date"
                    id="fromdate"
                    name="fromdate"
                    className="form-control"
                    placeholder="fromdate"
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>
                <div>
                  <label>To date</label>
                  <Input
                    type="date"
                    id="todate"
                    name="todate"
                    className="form-control"
                    placeholder="todate"
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={HandleFilter}
                >
                  Filter
                </button>
              </div>
              <div className="r-g-a-fe-6">
                <button className="btn btn-primary btn-sm text-nowrap">
                  Export CSV
                </button>

                <button className="btn btn-primary btn-sm">Refresh</button>
              </div>
            </div>
          </Col>
        </Row>
        <table className="table text-center mt-3">
          <thead>
            <tr>
              <th>Transaction Date</th>
              <th>User Name</th>
              <th>Email</th>
              <th>Currency</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Receive Amount</th>
              <th>Fee</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10">
                  <Spinner />
                </td>
              </tr>
            ) : displayData.length > 0 ? (
              displayData.map((address) => (
                <tr key={address?._id}>
                  <td>{formatDate(address?.createdDate)}</td>
                  <td>{address?.userId?.username || "-"}</td>
                  <td>{address?.userId?.email || "-"}</td>
                  <td>
                    {address?.currencyId?.currencySymbol} -{" "}
                    {address?.currencyId?.basecoin}
                  </td>
                  <td>{address?.type}</td>
                  <td>{address?.amount}</td>
                  <td>{address?.receiveAmount}</td>
                  <td>
                    {address?.fees} {address?.currencyId?.currencySymbol}
                  </td>
                  <td>
                    {{
                      1: "Completed",
                      0: "Pending",
                      2: "Rejected",
                    }[address?.status] || "Processing"}
                  </td>
                  <td>
                    <Link
                      to={`/transaction-list/${address?._id}`}
                      className="btn btn-primary btn-sm"
                    >
                      View
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10">No records found</td>
              </tr>
            )}
          </tbody>
        </table>
      </Container>
    </div>
  );
};

export default TransactionList;
